module.exports = __webpack_public_path__ + "img/undraw_begin_chat_re_v0lw.4e628eb8.svg";